import { get, getAll } from "../utilities/querySelector";


const siteHeader = get( '#site-header' );
const menuToggles = getAll( '[aria-controls=primary-navigation]', siteHeader );
const siteLogo = get( '.site-header__logo', siteHeader );

window.addEventListener( 'scroll', setHeaderState, { passive: true } );
window.addEventListener( 'resize', setHeaderState, { passive: true } );
setHeaderState();

function setHeaderState( e ) {
  if ( window.scrollY > 80 ) {
    siteHeader.dataset.scrolled = 'true';
    // siteLogo.src = siteLogo.dataset.scrolledImg;
  } else {
    siteHeader.dataset.scrolled = 'false';
    // siteLogo.src = siteLogo.dataset.unscrolledImg;
  }
}

